import { ReactNode, useEffect, useRef } from 'react';

import { Card } from 'apps/shared/scripts/__generated__/graphql.generated';

interface Props {
  children: ReactNode;
  design: Card['design'];
}

const CardTheme = ({ children, design }: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  const html = document.documentElement;
  const body = document.body;
  const root = document.getElementById('root');

  useEffect(() => {
    if (!design || !html || !body || !root || !ref.current) {
      return;
    }
    const { color, background } = design;
    html.style.height = '100%';
    body.style.backgroundColor = background.color;
    body.style.height = '100%';
    root.style.height = '100%';
    ref.current.style.setProperty('--card-color-accent', color);
    ref.current.style.setProperty('--card-color-text', '#FFFFFF');
    ref.current.style.background = `url(${background.src})`;
    ref.current.style.backgroundAttachment = background.attachment;
    ref.current.style.backgroundSize = background.size;
    ref.current.style.minHeight = '100%';
    (
      document.querySelector('meta[name="theme-color"]') as HTMLMetaElement
    ).content = background.color;
    return () => {
      body.style.backgroundColor = '#FFFFFF';
    };
  }, [body, design, html, root]);

  return <div ref={ref}>{children}</div>;
};

CardTheme.displayName = 'CardTheme';

export default CardTheme;
